import BaseController from "./base_controller"

export default class extends BaseController {
  static outlets = ["design-system--slide-over-component"]

  handleClick(event) {
    this.designSystemSlideOverComponentOutlet.open()
  }
}
